export const REQUIRED_DOCUMENTS_BUYER = {
    "Traditional FHA & Conventional (3.5% Down)": [],
    "Self-Employed / Business Owners (3-5% Down)": [],
    "ITIN Premier W-2 (6% Down Minimum)": [],
    "Self-Employed ITIN - Cash Earners (20% Down Minimum)": [],
    "Written VOE - WVOE (3.5% Down)": [],
    "W2 Premier - Self-Employed & Business Owner": [],
    "Hard Money Loan": [],
    "Refinance FHA & Conventional W2": [],
    "Refinance FHA & Conventional Self-Employed & Business Owners": [],
    "Commercial -10% Downpayment": [],
}

export const BUYER_PROGRAM_LOAN_TYPE = [
    "Traditional FHA & Conventional (3.5% Down)",
    "Self-Employed / Business Owners (3-5% Down)",
    "ITIN Premier W-2 (6% Down Minimum)",
    "Self-Employed ITIN - Cash Earners (20% Down Minimum)",
    "Written VOE - WVOE (3.5% Down)",
    "W2 Premier - Self-Employed & Business Owner",
    "Hard Money Loan",
    "Refinance FHA & Conventional W2",
    "Refinance FHA & Conventional Self-Employed & Business Owners",
    "Commercial -10% Downpayment",
];

export const BUYER_PROGRAM_STEPS_STATUS = [
    { label: 'PENDING', value: 'pending' },
    { label: 'WAIVED', value: 'waived' },
    { label: 'ACTIVE', value: 'active' },
    { label: 'COMPLETED', value: 'completed' },
    { label: 'CANCELED', value: 'canceled' },
];


const BASE_STEPS_TEMPLATE = [
    {
        name: 'Open Escrow',
        order: 1,
        estimated_days: 0,
        affect_delay: [2, 3, 4, 5, 6, 7, 8, 9]
    },
    {
        name: "Buyer's Deposit",
        order: 2,
        estimated_days: 3,
        affect_delay: [3, 4, 5, 6]
    },
    {
        name: 'Review of Seller Disclousures',
        order: 3,
        estimated_days: 7,
        affect_delay: [9]
    },
    {
        name: 'Inspections Contingency',
        order: 4,
        estimated_days: 10,
        affect_delay: [5, 6, 9]
    },
    {
        name: 'Appraisal Contingecy',
        order: 5,
        estimated_days: 17,
        affect_delay: [6, 7]
    },
    {
        name: 'Release Loan Contingency',
        order: 6,
        estimated_days: 17,
        affect_delay: [7, 8, 9]
    },
    {
        name: 'Clear to Close (CTC)',
        order: 7,
        estimated_days: 15,
        affect_delay: [8, 9]
    },
    {
        name: 'Closing Disclosure (CD)',
        order: 8,
        estimated_days: 21,
        affect_delay: [9]
    },
]

const BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_30 = [
    ...BASE_STEPS_TEMPLATE,
    {
        name: 'Closing Date',
        order: 9,
        estimated_days: 30,
    },
]

const BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_45 = [
    ...BASE_STEPS_TEMPLATE,
    {
        name: 'Closing Date',
        order: 9,
        estimated_days: 45,
    },
]

export const BUYER_PROGRAM_LOAN_TYPE_STEPS = {
    "Traditional FHA & Conventional (3.5% Down)": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_30,
    "Self-Employed / Business Owners (3-5% Down)": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_30,
    "ITIN Premier W-2 (6% Down Minimum)": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_45,
    "Self-Employed ITIN - Cash Earners (20% Down Minimum)": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_45,
    "Written VOE - WVOE (3.5% Down)": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_45,
    "W2 Premier - Self-Employed & Business Owner": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_30,
    "Hard Money Loan": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_30,
    "Refinance FHA & Conventional W2": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_30,
    "Refinance FHA & Conventional Self-Employed & Business Owners": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_30,
    "Commercial -10% Downpayment": BASE_STEPS_TEMPLATE_WITH_CLOSING_DATE_30,
}